"use strict";

exports.__esModule = true;
exports.packingCategoriesRoute = packingCategoriesRoute;
exports.PackingCategoryPath = exports.PackingCategorySegment = exports.PackingCategoryTitle = exports.PackingCategoriesTitle = void 0;

var _createRoute = require("../../../../../react-static/route/createRoute");

var _getPath = require("../../../../../react-static/route/getPath");

var _slugify = require("../../../../../html/slugify");

var _Packing = require("../Packing");

var _ThingTypesInCategoryTemplate = require("./thingTypesInCategoryTemplate/ThingTypesInCategoryTemplate");

var PackingCategoriesTitle = "Packing List Categories";
exports.PackingCategoriesTitle = PackingCategoriesTitle;
var PackingCategoryTitle = "Category";
exports.PackingCategoryTitle = PackingCategoryTitle;
var PackingCategorySegment = "category";
exports.PackingCategorySegment = PackingCategorySegment;
var PackingCategoryPath = (0, _getPath.getPath)(PackingCategorySegment, _Packing.PackingPath);
exports.PackingCategoryPath = PackingCategoryPath;

function packingCategoriesRoute(rootPath, packingCategories) {
  var categories = packingCategories.edges.map(function (packingCategoryEdge) {
    var category = packingCategoryEdge.node;
    var categorySlug = (0, _slugify.slugify)(category.name);
    var url = (0, _ThingTypesInCategoryTemplate.ThingTypesInCategoryTemplatePath)(categorySlug); // TODO toNumberString function with radix or something

    return {
      id: category.id.toString(),
      parent_id: category.parentId ? category.parentId.toString() : null,
      name: category.name,
      url: url
    };
  });
  var route = (0, _createRoute.createRoute)(rootPath, PackingCategoryPath);

  route.getData = function () {
    return {
      path: PackingCategoryPath,
      categories: categories
    };
  };

  return route;
}